import type { FieldState } from "@/domains/buildings/types/buildingWidget";

interface FieldControlState {
  canManage: boolean;
  editing: boolean;
  proposalActive: boolean;
  isSaving: boolean;
  state: FieldState;
  valueOutsideEnum: boolean;
}

/**
 * Whether the row shows its hover control tray.
 *
 * A confirmed row earns one now too: clicking a saved value used to drop the
 * row into an inline editor *and* open the attribute panel at the same time, so
 * the panel arrived with a text input already grabbing the row. The click now
 * belongs to the panel alone and the tray's pencil is what starts an inline
 * edit — the same pencil a "Needs review" row has always offered.
 *
 * Still no tray while a proposal is live: the tray and the "New finding" badge
 * occupy the same corner, and swapping the badge out on hover would take away
 * the disclosure exactly as the pointer reached it.
 */
export function hasFieldControls(state: FieldControlState): boolean {
  if (!state.canManage || state.editing || state.proposalActive) return false;
  return state.isSaving || state.state === "pending" || state.state === "confirmed";
}
